import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Sidebar from './Sidebar'
import MainMenu from './MainMenu'
import DynamicSection from './DynamicSection'
import * as ComponentActions from '../actions'
import commonUI from '../../js/commonUI'
import { initPlugins } from '../lib/utils'

class Brand extends Component {

  constructor({ components }) {
    super()
  }

  componentDidMount() {
    setTimeout(() => {
      commonUI.initializeNavigation();
      initPlugins();
    }, 0)
  }

  getFilteredContent(components) {
    return components.Brand
  }

  renderMainMenu(components, staticVersion) {
    return (<MainMenu components={components} selected="Brand" staticVersion={staticVersion} />)
  }

  renderSidebar(filteredContent, staticVersion) {
    return (<Sidebar sections={filteredContent} selected="Brand" staticVersion={staticVersion} />)
  }

  render (){
    const { components } = this.props
    const staticVersion = this.props.config.staticVersion;
    const filteredContent = this.getFilteredContent(components);

    return(
      <div>
        {this.renderMainMenu(components, staticVersion)}
        {this.renderSidebar(filteredContent, staticVersion)}
        <div id="main" className="content">
          <div className="grid">
            <div className="grid__col-sm-12 main">
              {filteredContent.map((object, index) => {
                return (
                  <DynamicSection
                    key={object.template}
                    sectionName={object.template}
                    onIncludeClick={() => this.handleIncludeClick('Brand', index, object.include)}
                    included={object.include}
                    staticVersion={staticVersion}/>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(ComponentActions, dispatch)
  }
}

function mapStateToProps(state) {
  return { components: state.components, config: state.config }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Brand)



// WEBPACK FOOTER //
// ./styleguide/components/Brand.js